export default "__VITE_ASSET__Cay0VOUc__"